import { AdyenPaymentImportResult } from '../types/adyenPaymentImport';

export function formatAdyenPaymentImportResult(result: AdyenPaymentImportResult): string {
  const count = result.importableRowCount.toLocaleString();
  const parts = [`${count} transaction${result.importableRowCount === 1 ? '' : 's'} imported`];
  if (result.skippedRowCount > 0) parts.push(`${result.skippedRowCount.toLocaleString()} rows skipped`);
  if (result.metricsDatesRecalculated > 0) {
    parts.push(`Transaction metrics recalculated for ${result.metricsDatesRecalculated} date${result.metricsDatesRecalculated === 1 ? '' : 's'}`);
  }
  return parts.join(', ');
}
